// Small helpers shared by the bootstrap, the integrations and the banner UI.

/** Fired by the UI bundle once it has executed; carries its mount function to the bootstrap. */
export const UI_READY_EVENT = 'consent-banner:ui-ready';

/** Fired on `window` after the visitor saves a decision or consent is reset. */
export const CHANGE_EVENT = 'consent-banner:change';

export function isObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

export function warn(...args) {
  console.warn('[consent-banner]', ...args);
}

/** Resolves http(s) and relative URLs against `base`; anything else (javascript:, data:, …) is null. */
export function safeUrl(value, base) {
  if (typeof value !== 'string' || !value.trim()) return null;
  try {
    const url = new URL(value.trim(), base);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null;
  } catch {
    return null;
  }
}

export function injectScript(doc, src, { nonce, onError } = {}) {
  const script = doc.createElement('script');
  script.async = true;
  script.src = src;
  if (nonce) script.setAttribute('nonce', nonce);
  if (onError) script.addEventListener('error', onError);
  (doc.head || doc.documentElement).appendChild(script);
  return script;
}

/** The tag loader `src` plus the `id` (and, for a non-default dataLayer, `l`) params. Params already on `src` are kept. */
export function tagUrl(src, id, dataLayer) {
  const url = new URL(src);
  url.searchParams.set('id', id);
  if (dataLayer !== 'dataLayer') url.searchParams.set('l', dataLayer);
  return url.href;
}

/**
 * Finds a script already on the page that loads tag `id`: one from the configured `src` (same
 * origin and path), or one serving the standard `pathSuffix` from any host, e.g. a host's own snippet.
 */
export function findScript(doc, { id, src, pathSuffix }) {
  const target = new URL(src);
  for (const script of Array.from(doc.scripts)) {
    if (!script.src) continue;
    try {
      const url = new URL(script.src);
      if (url.searchParams.get('id') !== id) continue;
      if (url.pathname.endsWith(pathSuffix) || (url.origin === target.origin && url.pathname === target.pathname)) return script;
    } catch {
      // Unparsable src: not a Google tag.
    }
  }
  return null;
}
